import { Box, Grid } from "@mui/material";
import ClientCard from "components/ui/ClientFlow/ClientCard";
import React from "react";
import { useQuotes } from "./Api";
import { useParams } from "react-router-dom";
import TransactionSmallCard from "components/ui/Skeleton/TransactionSmallCard";

const bgColors = {
  "All quotes": "linear-gradient(180deg, #5B88E2 0%, #324A7C 97.9%)",
  "Pending quotes": "linear-gradient(180deg, #E6DA5D 0%, #7C7532 97.9%)",
  "Completed quotes": "linear-gradient(180deg, #5BE272 0%, #327C3E 97.9%)",
  "Cancelled quotes": "linear-gradient(180deg, #E25B5B 0%, #7C3232 97.9%)",
};

function QuotePage() {
  const { clientId } = useParams();
  const { data: apiData, isLoading } = useQuotes(clientId);

  if (isLoading) {
    return <TransactionSmallCard count={4} />;
  }

  const quoteData =
    apiData?.map((item) => ({
      name: item.label,
      count: item.quotesCount,
      bg: bgColors[item.label],
      details: [
        {
          icon: "RedBag",
          count: item.bagQuantity,
        },
        // {
        //   icon: "Small_Diamond",
        //   count: "0Ct",
        // },
        // {
        //   icon: "GoldBar",
        //   count: "0g",
        // },
      ],
    })) || [];

  return (
    <>
      {quoteData?.length && (
        <Grid container sx={{ display: "flex", gap: "2rem" }}>
          {quoteData.length &&
            quoteData.map((data) => {
              return (
                <Grid item sx={{ padding: "0px !important" }}>
                  <ClientCard data={data} showLine={true} page="purchase" />
                </Grid>
              );
            })}
        </Grid>
      )}
    </>
  );
}

export default QuotePage;
